<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="flex overflow-hidden p-2">
				<HelpfulTips>
					Snapping some pictures of your ride and its features is optional, but it helps
					us get to know your car better. Feel free to skip this step if you'd like.
				</HelpfulTips>

				<div class="grow basis-1/2 overflow-y-auto">
					<AppImageUpload
						ref="uploader"
						v-model="form.images"
						:max-files="10"
						@progressChange="
							eventBus.emit({
								name: EVENT_BUS_EVENTS.UPLOAD_IMAGES_PROGRESS,
								data: $event,
							})
						"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useFormStore } from '../../../stores/form'
	import { ref } from 'vue'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import AppImageUpload from '../../common/AppImageUpload.vue'
	import { useEventBus, EVENT_BUS_EVENTS } from '../../../stores/eventBus'

	const form = useFormStore()
	const eventBus = useEventBus()

	const uploader = ref()

	eventBus.$onAction(({ args }) => {
		if (args[0].name === EVENT_BUS_EVENTS.CANCEL_UPLOAD_IMAGES) uploader.value?.cancelUpload()
	})
</script>
